export default __webpack_public_path__ + "static/media/KASBM.fcb744e1.png";